module.exports = __webpack_public_path__ + "static/media/logoTestShop.dc5dd333.png";